module.exports = __webpack_public_path__ + "static/img/haitang.ccbc178.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/haitang.png
// module id = ie8s
// module chunks = 1